import { X } from 'lucide-react';

interface NewsletterModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function NewsletterModal({ isOpen, onClose }: NewsletterModalProps) {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4"
      onClick={onClose}
    >
      <div
        className="relative bg-white rounded-lg shadow-xl max-w-lg w-full overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors z-10 bg-white rounded-full p-1 shadow-md"
          aria-label="Close newsletter modal"
        >
          <X className="w-5 h-5" />
        </button>

        {/* MailerLite iframe - using the form's share URL */}
        <iframe
          src="https://preview.mailerlite.io/forms/1830380/167722090306209260/share"
          width="100%"
          height="550"
          style={{ border: 'none' }}
          title="Newsletter Signup"
        />
      </div>
    </div>
  );
}
